import { composeIO } from 'react-compose-io'
import { debitoInicialTransportadoraBoxIO } from './DebitoInicialTransportadoraBox.IO'
import { DebitoInicialTransportadoraBoxView } from './DebitoInicialTransportadoraBox.View'

export const DebitoInicialTransportadoraBox = composeIO(DebitoInicialTransportadoraBoxView, debitoInicialTransportadoraBoxIO)
